<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-11 15:34:19
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-07-14 16:40:46
 * @FilePath: \newpigboxmanger\src\views\shopdata.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="shopDataBody">
    <div class="myTopBox">
      <div class="topLeft">
        <div class="topLeftTitle">店铺收益</div>
        <div class="leftMainBox">
          <div class="leftMainBoxItem">
            <div style="width:100%">今日收益</div>
            <div style="width:100%;color:red">￥{{myDataLsit.todayIncome}}</div>
          </div>
          <div class="leftMainBoxItem">
            <div style="width:100%">可提现余额</div>
            <div style="width:100%;color:red">￥{{myDataLsit.balance}}</div>
          </div>
          <div class="leftMainBoxItem2">
            <div style="width:100%">本周收益</div>
            <div style="width:100%;color:red">￥{{myDataLsit.weekIncome}}</div>
          </div>
          <div class="leftMainBoxItem2">
            <div style="width:100%">本月收益</div>
            <div style="width:100%;color:red">￥{{myDataLsit.monthIncome}}</div>
          </div>
        </div>
      </div>
      <div class="topRight">
        <div class="topLeftTitle">访客与评分</div>
        <div class="leftMainBox">
          <div class="leftMainBoxItem">
            <div style="width:100%">店铺评分</div>
            <div style="width:100%;color:red">{{myDataLsit.merchantStar}}星</div>
          </div>
          <div class="leftMainBoxItem">
            <div style="width:100%">今日访客</div>
            <div style="width:100%;color:red">{{myDataLsit.todayVisitor}}人</div>
          </div>
          <div class="leftMainBoxItem">
            <div style="width:100%">已完成订单</div>
            <div style="width:100%;color:red">{{myDataLsit.completeOrder}}</div>
          </div>
          <div class="leftMainBoxItem">
            <div style="width:100%">转换率</div>
            <div style="width:100%;color:red">5.7%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="myTopBox2" ref="mychart"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      myDataLsit: {},
      userId:""
    };
  },
  mounted() {
       this.userId = this.$store.state.userData
    // this.initEcharts();
    this.getshopData();
  },
  methods: {
    getshopData() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/pigbox/MerchantService/queryMerchantRevenue/${this.userId}`
      }).then(res => {
        console.log(res.data);
        this.myDataLsit = res.data;
        this.initEcharts(res.data.weekTotal)
      });
    },
    initEcharts(data) {
      const option = {
        title: {
          text: "本周收益图",
          x: "center", //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
          y: "top",
          padding: 10
        },
        grid: {
          x: 50,
          y: 50,
          x2: 50,
          y2: 50
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: data,
            type: "line",
            smooth: true,
            itemStyle : { normal: {label : {show: true}}}
          }
        ]
      };
      const myChart = echarts.init(this.$refs.mychart); // 图标初始化
      myChart.setOption(option); // 渲染页面
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    }
  }
};
</script>

<style>
.shopDataBody {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  /* background-color: #fff; */
}
.myTopBox {
  height: 48%;
  width: 100%;

  display: flex;
  justify-content: space-between;
  /* background-color: aqua; */
}
.myTopBox2 {
  height: 48%;
  width: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #545c64;
  /* background-color: aqua; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.topLeft {
  overflow: hidden;
  width: 48%;
  height: 100%;
  background-color: white;
  border-radius: 25px;
  border: 1px solid #545c64;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.topRight {
  width: 48%;
  height: 100%;
  background-color: white;
  border-radius: 25px;
  border: 1px solid #545c64;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.topLeftTitle {
  width: 100%;
  height: 50px;
  text-align: center;

  line-height: 50px;
}
.leftMainBox {
  height: calc(100% - 50px);
  width: 100%;
  /* background-color: aqua; */
  display: flex;
  flex-wrap: wrap;
}
.leftMainBoxItem {
  height: 50%;
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  font-weight: 700;
  font-size: 25px;
}
.leftMainBoxItem2 {
  height: 50%;
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  font-size: 20px;
}
</style>